"use client";

import { c as _c } from "react/compiler-runtime";
import { GET_RBI_PRICE_INDEX_QUERY } from "@/gql/sup";
import { useQuery } from "@apollo/client";
import { useMemo } from "react";

/**
 * House Price Index (HPI) Quarter Data Type
 * Base Year: 2010-11 = 100
 * Source: RBI (Reserve Bank of India)
 */
export interface HPIQuarterData {
  quarter: string;
  value: number;
}
interface RBIPriceIndexResponse {
  seller: {
    getRBIPriceIndex: {
      data: {
        quarter: string;
        index: number;
      }[];
      latestQuarter: string;
      latestIndex: number;
    };
  };
}

/**
 * Hook to fetch House Price Index data from the backend GraphQL API
 * Data is fetched from the RBI Price Index endpoint
 *
 * @param skip - Optional flag to skip the query (useful for conditional fetching)
 */
export function useHPIData(t0) {
  const $ = _c(11);
  const skip = t0 === undefined ? false : t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      params: {
        getRBIPriceIndex: {
          _empty: null
        }
      }
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== skip) {
    t2 = {
      variables: t1,
      fetchPolicy: "cache-first",
      skip
    };
    $[1] = skip;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const {
    data: queryData,
    loading,
    error
  } = useQuery(GET_RBI_PRICE_INDEX_QUERY, t2);
  let t3;
  bb0: {
    if (!queryData?.seller?.getRBIPriceIndex?.data) {
      t3 = null;
      break bb0;
    }
    let t4;
    if ($[3] !== queryData.seller.getRBIPriceIndex.data) {
      t4 = queryData.seller.getRBIPriceIndex.data.map(_temp);
      $[3] = queryData.seller.getRBIPriceIndex.data;
      $[4] = t4;
    } else {
      t4 = $[4];
    }
    t3 = t4;
  }
  const data = t3;
  const latestQuarter = queryData?.seller?.getRBIPriceIndex?.latestQuarter;
  const latestIndex = queryData?.seller?.getRBIPriceIndex?.latestIndex;
  let t4;
  if ($[5] !== data || $[6] !== error || $[7] !== latestIndex || $[8] !== latestQuarter || $[9] !== loading) {
    t4 = {
      data,
      loading,
      error,
      latestQuarter,
      latestIndex
    };
    $[5] = data;
    $[6] = error;
    $[7] = latestIndex;
    $[8] = latestQuarter;
    $[9] = loading;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
}
function _temp(item) {
  return {
    quarter: item.quarter,
    value: item.index
  };
}